import onDomReady from './../onDomReady';
import button from 'bootstrap/js/src/button';

onDomReady(() => {
	$(function () {
		var class_menu_open = 'target-open',
			header_master = $('header#master'),
			entry_popup = $('.entry-popup'),
			entry_popup_background = $('#entry-popup-background');

		$(document).on('click', '.header-button', function () {
			var target = $($(this).data('target'));

			if (!$(this).hasClass(class_menu_open)) {
				entry_popup.removeClass('show');
				$('.header-button')
					.removeClass(class_menu_open)
					.attr('aria-expanded', 'false');
				$(this).addClass(class_menu_open).attr('aria-expanded', 'true');
				//$('html, body').addClass('no-scroll');
				target.addClass('show');
				entry_popup.addClass('open');
				entry_popup_background.addClass('open');
			} else if ($(this).hasClass(class_menu_open)) {
				entry_popup.removeClass('show');
				entry_popup_background.removeClass('open');
				$('.header-button')
					.removeClass(class_menu_open)
					.attr('aria-expanded', 'false');
				//$('html, body').removeClass('no-scroll');
			}
			if (!entry_popup.hasClass('show')) {
				entry_popup.removeClass('open');
				entry_popup_background.removeClass('open');
			}
		});

		$(document).on('click', '.entry-popup .close', function () {
			entry_popup.removeClass('open').removeClass('show');
			entry_popup_background.removeClass('open');
			$('.header-button')
				.removeClass(class_menu_open)
				.attr('aria-expanded', 'false');
			//$('html, body').removeClass('no-scroll');
		});

		if (location.hash === '#reservation') {
			$('.header-button.button-reservation').trigger('click');
		}

		// function headerResize() {
		// 	var master_padding = $('.master-padding'),
		// 		header_logo = $('.header-logo img'),
		// 		limit_max = 65,
		// 		limit_min = 45,
		// 		padding_min = 10,
		// 		padding_max = 17,
		// 		offset_limit = list_page_header_max_height() + limit_max,
		// 		scrollPosition = $(window).scrollTop(),
		// 		logo_height = limit_max - ((limit_max - limit_min) * scrollPosition / offset_limit),
		// 		padding = (padding_max - padding_min) * scrollPosition / offset_limit;
		//
		// 	if (scrollPosition <= offset_limit && $(window).outerWidth() > 580) {
		// 		header_logo.css('height', Math.round(logo_height) + 'px');
		// 		master_padding.css({
		// 			'padding-top': Math.round(padding_max - padding) + 'px',
		// 			'padding-bottom': Math.round(padding_max - padding) + 'px'
		// 		});
		// 	} else {
		// 		header_logo.css('height', limit_min + 'px');
		// 		master_padding.css({
		// 			'padding-top': padding_min + 'px',
		// 			'padding-bottom': padding_min + 'px'
		// 		});
		// 	}
		// }

		// $(window).on('resize scroll', function () {
		// 	headerResize();
		// });

		$(window).on('resize', function () {
			setMenuHeight();
		});

		var current_item = $('.current-item:not(.has-submenu)');
		current_item.parents('.dl-submenu').addClass('dl-subview-open');
		current_item.parents('.has-submenu').addClass('dl-subview selected');
		current_item
			.closest('.dl-submenu')
			.addClass('active-submenu dl-subview-open');
		current_item.closest('.item-parent').addClass('selected');

		$(document).on('click', '.dl-menu a', function () {
			var button = $(this);
			var button_li = $(this).parent('.item-parent');
			var submenu_class = '.dl-submenu';
			if (button_li.hasClass('item-parent')) {
				button_li.removeClass('selected');
				$(submenu_class).removeClass('active-submenu dl-subview-open');
				$('.dl-menu .item').removeClass('dl-subview');
				setActiveMenu();
				setMenuHeight();
			}
			if (button.hasClass('has-children')) {
				button
					.closest('ul.active-submenu')
					.removeClass('active-submenu');
				button.parent().addClass('dl-subview');
				button
					.next(submenu_class)
					.addClass('active-submenu dl-subview-open');
				setActiveMenu();
				setMenuHeight();
				return false;
			}
			if (button.hasClass('button-back')) {
				button
					.closest(submenu_class)
					.removeClass('active-submenu dl-subview-open');
				button
					.closest('.dl-subview')
					.closest(submenu_class)
					.addClass('active-submenu dl-subview-open');
				button
					.closest('.dl-subview')
					.removeClass('dl-subview selected');
				setActiveMenu();
				setMenuHeight();
				return false;
			}
		});

		$(document).on('click', '.dl-menu .button-back', function () {
			var button = $(this);
			var submenu_class = '.dl-submenu';
			button
				.closest(submenu_class)
				.removeClass('active-submenu dl-subview-open');
			button
				.closest('.dl-subview')
				.closest(submenu_class)
				.addClass('active-submenu dl-subview-open');
			button.closest('.dl-subview').removeClass('dl-subview selected');
			setActiveMenu();
			setMenuHeight();
		});

		function setMenuHeight() {
			if ($('.dl-subview-open').hasClass('active-submenu')) {
				var active_menu_height = $('.active-submenu').height();
				$('.dl-menu').css('min-height', active_menu_height + 'px');
			} else {
				$('.dl-menu').css('min-height', 'inherit');
			}
		}

		function setActiveMenu() {
			if ($('.dl-submenu').hasClass('active-submenu')) {
				$('.dl-menu').addClass('active-menu');
			} else {
				$('.dl-menu').removeClass('active-menu');
			}
		}

		// headerResize();
		setActiveMenu();
	});
});
